"use strict";

exports.__esModule = true;
exports.default = void 0;

var _Provider = _interopRequireDefault(require("../../providers/AddToHomeScreen/Provider"));

var _Provider2 = _interopRequireDefault(require("../../providers/Auth/Provider"));

var _Provider3 = _interopRequireDefault(require("../../providers/Config/Provider"));

var _Provider4 = _interopRequireDefault(require("../../providers/Online/Provider"));

var _react = _interopRequireWildcard(require("react"));

var _Provider5 = _interopRequireDefault(require("../../providers/SimpleValues/Provider"));

var _Provider6 = _interopRequireDefault(require("../../providers/Update/Provider"));

var _config = _interopRequireDefault(require("../../config"));

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const Layout = (0, _react.lazy)(() => Promise.resolve().then(() => _interopRequireWildcard(require('../../containers/Layout/Layout'))));

const App = ({
  config: appConfig
}) => {
  const config = { ..._config.default,
    ...appConfig
  };
  const {
    pages,
    components,
    containers,
    update,
    auth
  } = config;
  const {
    persistKey
  } = auth || {};
  const {
    LandingPage = false
  } = pages || {};
  const {
    checkInterval = 5000
  } = update || {};
  const {
    Loading = () => /*#__PURE__*/_react.default.createElement("div", null)
  } = components || {};
  const {
    AppContainer = _react.default.Fragment
  } = containers || {};
  return /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(Loading, null)
  }, /*#__PURE__*/_react.default.createElement(_Provider5.default, null, /*#__PURE__*/_react.default.createElement(_Provider2.default, {
    persistKey: persistKey
  }, /*#__PURE__*/_react.default.createElement(_Provider3.default, {
    appConfig: config
  }, /*#__PURE__*/_react.default.createElement(_Provider.default, null, /*#__PURE__*/_react.default.createElement(_Provider6.default, {
    checkInterval: checkInterval
  }, /*#__PURE__*/_react.default.createElement(AppContainer, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.BrowserRouter, null, /*#__PURE__*/_react.default.createElement(_Provider4.default, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, LandingPage && /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/",
    exact: true,
    component: LandingPage
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    component: Layout
  })))))))))));
};

var _default = App;
exports.default = _default;
module.exports = exports.default;